import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  // Values encrypted with this key only ever live in sessionStorage and are
  // decrypted within the same browser session, so a random per-session key
  // works identically to a fixed one while keeping the key out of source
  // control and out of the shipped bundle.
  private static readonly KEY_STORAGE_NAME = 'enc_session_key';

  private get key(): string {
    let key = sessionStorage.getItem(EncryptionService.KEY_STORAGE_NAME);
    if (!key) {
      key = CryptoJS.lib.WordArray.random(32).toString();
      sessionStorage.setItem(EncryptionService.KEY_STORAGE_NAME, key);
    }
    return key;
  }

  constructor() { }

  encrypt(data: string): string {
    const ciphertext = CryptoJS.AES.encrypt(data, this.key).toString();
    return ciphertext;
  }

  decrypt(ciphertext: string): string {
    const bytes = CryptoJS.AES.decrypt(ciphertext, this.key);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  }
}
